function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_svg__cls-2{fill:#cb3694}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f499c1",
  d: "M154.29 60.19v187.47l74-40.45 13.82-114.46-87.82-32.56z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M153.19 249.52V58.61L243.31 92l-.11.86-13.88 115zm2.21-187.74v184l71.86-39.29 13.65-113z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#eecde2",
  d: "M154.29 60.19L66.48 92.75l13.81 117.41 74 37.5V60.19z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M155.4 249.45l-76.13-38.57L65.28 92l90.12-33.39zm-74.08-40l71.87 36.41V61.78l-85.51 31.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M154.51 254.85l-80.29-40.69-5.5-121.12 12.71-.58 5.16 113.71 67.7 34.3 67.92-37.13 5.16-110.88 12.71.59-5.49 118.02-80.08 43.78z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M154.54 256.09l-81.4-41.23v-.65L67.57 92l14.91-.68v1.1l5.13 113.07 66.61 33.74 66.87-36.55 5.23-111.38 14.91.7v1.1l-5.52 118.64zm-79.26-42.62l79.21 40.13 79-43.2 5.41-116.3-10.51-.49-5.1 110.39-69 37.71-68.77-34.85v-.64L80.38 93.61l-10.51.48z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M241.97 93.41L154.4 60.95 66.83 93.41l-.49-1.32 88.06-32.65 88.06 32.65-.49 1.32z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M242.62 94.83L154.4 62.12 66.19 94.83l-1.27-3.39 89.48-33.18 89.48 33.18-1.26 3.39z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "icon_svg__cls-2",
  cx: 74.42,
  cy: 93.44,
  r: 14.84
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M74.42 109.39a15.95 15.95 0 1116-16 16 16 0 01-16 16zm0-29.69a13.74 13.74 0 1013.75 13.74A13.76 13.76 0 0074.42 79.7z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "icon_svg__cls-2",
  cx: 235.57,
  cy: 93.44,
  r: 14.84
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M235.57 109.39a15.95 15.95 0 1116-16 16 16 0 01-16 16zm0-29.69a13.74 13.74 0 1013.75 13.74 13.76 13.76 0 00-13.75-13.74z"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "icon_svg__cls-2",
  cx: 81.49,
  cy: 209.36,
  r: 14.84
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M81.49 225.3a15.95 15.95 0 1116-15.94 16 16 0 01-16 15.94zm0-29.68a13.74 13.74 0 1013.74 13.74 13.76 13.76 0 00-13.74-13.74z"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "icon_svg__cls-2",
  cx: 227.09,
  cy: 209.36,
  r: 14.84
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M227.09 225.3A15.95 15.95 0 11243 209.36a16 16 0 01-15.91 15.94zm0-29.68a13.74 13.74 0 1013.75 13.74 13.75 13.75 0 00-13.75-13.74z"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  className: "icon_svg__cls-2",
  cx: 155,
  cy: 247.53,
  r: 14.84
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M155 263.47a15.95 15.95 0 1115.94-15.94A16 16 0 01155 263.47zm0-29.68a13.74 13.74 0 1013.74 13.74A13.75 13.75 0 00155 233.79z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M154.29 60.22h1.41v188.01h-1.41z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  d: "M153.19 59.12h3.62v190.21h-3.62z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  transform: "rotate(-63.94 117.882 134.732)",
  d: "M34.89 134.02h166v1.41h-166z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  transform: "rotate(-63.94 117.903 134.734)",
  d: "M33.79 132.92h168.2v3.62H33.79z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  transform: "rotate(-26.09 190.937 134.739)",
  d: "M190.2 51.73h1.41v166h-1.41z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "icon_svg__cls-2",
  transform: "rotate(-26.09 190.937 134.739)",
  d: "M189.1 50.63h3.62v168.2h-3.62z"
});

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 310 310"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcon as ReactComponent };